<textarea
	[formControl]="formControl | fromAbstractToFormControl"
	class="form-control"
	[formlyAttributes]="field"
	[attr.aria-invalid]="showError"
	[attr.hasValue]="formControl?.value !== null && formControl?.value !== undefined"
	[class.is-invalid]="showError"></textarea>
